import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cart-widget__item" }
const _hoisted_2 = { class: "cart-widget__item__title" }
const _hoisted_3 = { class: "cart-widget__item__price" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, "pro Monat", -1)
const _hoisted_5 = { class: "card-widget__item__details" }

import Product from '@/classes/Product';
import Expand from '@/components/Expand.vue';
import PriceDetailsTable from '@/components/product/PriceDetailsTable.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTrashAlt } from '@fortawesome/pro-light-svg-icons';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppCartItem',
  props: {
    itemKey: {},
    product: {}
  },
  setup(__props: any) {

library.add(faTrashAlt);

const props = __props;

const hasCategoryImage = computed(() => !!props.product.category.image?.url);

return (_ctx: any,_cache: any) => {
  const _component_LazyBackgroundMedia = _resolveComponent("LazyBackgroundMedia")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (hasCategoryImage.value)
        ? (_openBlock(), _createBlock(_component_LazyBackgroundMedia, {
            key: 0,
            class: "cart-widget__item__icon",
            icon: "",
            "media-url": _ctx.product.category.image?.url,
            "background-position-y": "center",
            "background-position-x": "center",
            "no-repeat": ""
          }, null, 8, ["media-url"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, _toDisplayString(_ctx.product.name), 1),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "btn-remove-item",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$.emit('remove')))
          }, [
            _createVNode(_component_FontAwesomeIcon, { icon: _unref(faTrashAlt) }, null, 8, ["icon"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", null, _toDisplayString(_ctx.product.getPriceFormatted('monthly')) + " €", 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(Expand, { title: "Produktdetails" }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(PriceDetailsTable, {
              product: _ctx.product,
              key: `details-${_ctx.itemKey}`
            }, null, 8, ["product"]))
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})